import React from 'react';

const ExitIcon = () => (
  <svg
    width="18px"
    height="15px"
    viewBox="0 0 18 15"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-41.000000, -986.000000)"
        fill="#403645"
        fillRule="nonzero"
      >
        <g>
          <g>
            <g transform="translate(0.000000, 963.000000)">
              <g transform="translate(41.000000, 20.000000)">
                <path d="M7.14286566,16.2143015 C7.14286566,16.5268018 7.28795512,17.2857313 6.78572237,17.2857313 L3.21428955,17.2857313 C1.43973386,17.2857313 3.55271368e-15,15.8459975 3.55271368e-15,14.0714418 L3.55271368e-15,6.21428955 C3.55271368e-15,4.43973386 1.43973386,3 3.21428955,3 L6.78572237,3 C6.97545474,3 7.14286566,3.16741091 7.14286566,3.35714328 C7.14286566,3.66964366 7.28795512,4.42857313 6.78572237,4.42857313 L3.21428955,4.42857313 C2.23214552,4.42857313 1.42857313,5.23214552 1.42857313,6.21428955 L1.42857313,14.0714418 C1.42857313,15.0535858 2.23214552,15.8571582 3.21428955,15.8571582 L6.42857909,15.8571582 C6.70759728,15.8571582 7.14286566,15.8013545 7.14286566,16.2143015 Z M17.5000209,10.1428657 C17.5000209,10.332598 17.4218958,10.5111697 17.287967,10.6450984 L11.2165312,16.7165342 C11.0826025,16.8504629 10.9040309,16.928588 10.7142985,16.928588 C10.323673,16.928588 10.0000119,16.6049269 10.0000119,16.2143015 L10.0000119,13.0000119 L5.00000596,13.0000119 C4.60938049,13.0000119 4.28571939,12.6763508 4.28571939,12.2857254 L4.28571939,8.00000596 C4.28571939,7.60938049 4.60938049,7.28571939 5.00000596,7.28571939 L10.0000119,7.28571939 L10.0000119,4.07142985 C10.0000119,3.68080438 10.323673,3.35714328 10.7142985,3.35714328 C10.9040309,3.35714328 11.0826025,3.43526838 11.2165312,3.56919711 L17.287967,9.64063292 C17.4218958,9.77456165 17.5000209,9.95313329 17.5000209,10.1428657 Z"></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default ExitIcon;
